// 专业配置订单支付信息状态
export const orderStatus = [
  {
    status: 1,
    title: '待支付',
    description: '剩余支付时间',
    style: 'card-theme',
    headImg: require('@assets/images/order/unpaid.png'),
  },
  {
    status: 2,
    title: '已支付',
    description: '支付完成等待商家配货',
    style: 'card-theme',
    headImg: require('@assets/images/order/prepaid.png'),
  },
  {
    status: 3,
    title: '支付失败',
    description: '支付失败，请重新下单',
    style: 'card-default',
    headImg: require('@assets/images/order/cancel.png'),
  },
  {
    status: 4,
    title: '已取消',
    description: '付款超时订单已取消',
    style: 'card-default',
    headImg: require('@assets/images/order/cancel.png'),
  },
  {
    status: 5,
    title: '已完成',
    description: '商品已收货，交易完成',
    style: 'card-theme',
    headImg: require('@assets/images/order/completed.png'),
  },
  {
    status: 6,
    title: '退款中',
    description: '退款中，请稍候',
    style: 'card-theme',
    headImg: require('@assets/images/order/completed.png'),
  }
];

export const orderStatusForOrderList = [
  {
    status: 1,
    title: '待支付',
    style: 'font-red',
  },
  {
    status: 2,
    // title: "支付成功",
    title: '已支付',
    style: '', // 默认色 333
  },
  {
    status: 3,
    // title: "支付失败",
    title: '已取消',
    style: 'font-999', // 默认色 333
  },
  {
    status: 4,
    // title: "取消订单",
    title: '已取消',
    style: 'font-999',
  },
  {
    status: 5,
    title: '已完成',
    style: '', // 默认色 333
  },
  {
    status: 6,
    // title: "退款中",
    title: '已取消',
    style: 'font-999', // 默认色 333
  }
];

export const deliveryStatus = [
  {
    status: 1,
    title: '待支付',
    fontColor: 'font-red',
  },
  {
    status: 2,
    title: '已支付',
    fontColor: 'font-c111',
  },
  {
    status: 3,
    title: '待配货',
    fontColor: 'font-blue',
  },
  {
    status: 4,
    title: '已发货',
    fontColor: 'font-blue',
  },
  {
    status: 5,
    title: '已签收',
    fontColor: 'font-c111', // 默认 333
  },
  {
    status: 6,
    title: '已取消',
    fontColor: 'font-999',
  },
  {
    status: 7,
    title: '配送中',
    fontColor: 'font-blue',
  },
  {
    status: 8,
    title: '拒收',
    fontColor: 'font-blue',
  },
  {
    status: 9,
    title: '退款中',
    fontColor: 'font-999',
  }
];

// 支付类型及对应的名称
export const paymentOrRefundStatus = [
  {
    status: 1,
    desc: 'point card',
    title: '点卡',
    unit: '福豆',
  },
  {
    status: 2,
    desc: 'times card',
    title: '次卡',
    unit: '次',
  },
  {
    status: 3,
    desc: 'alipy',
    title: '支付宝',
    unit: '元',
  },
  {
    status: 4,
    desc: 'weixin native',
    title: '微信扫码',
    unit: '元',
  },
  {
    status: 4,
    desc: 'yinlian',
    title: '银联',
    unit: '元',
  },
  {
    status: 5,
    desc: 'weixin jsapi',
    title: '微信JSAPI',
    unit: '元',
  },
  {
    status: 7,
    desc: 'alipy_wap',
    title: '支付宝WAP',
    unit: '元',
  },
  {
    status: 8,
    desc: 'weixin company jsapi',
    title: '企业微信JSAPI',
    unit: '元',
  },
  {
    status: 13,
    desc: 'company point',
    title: '企业积分',
    unit: '福豆',
  }
];
